import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import ListDetailTop from "@/components/list-detail/listDetailTop.vue";
import ListDetail from "@/components/list-detail/listDetail.vue";
import Comment from "@/components/list-detail/Comment/Comment.vue";
import Loading from "@/baseui/loading/loading.vue";
import ListDetailNav from "@/components/list-detail/listDetailNav.vue";
export default defineComponent({
  name: "PlayListDetail",
  emits: ["changeCurrent"],
  setup: function setup() {
    var route = useRoute();
    var store = useStore();
    var state = useState("Detail", ["listDetail", "commentList"]);
    var isShow = ref(0);
    var curtpage = ref(1);
    /* 导航列表 */

    var navList = reactive(["歌曲列表", "评论"]);
    /* 歌单详情请求数据 */

    var listResData = reactive({
      id: route.params.id,
      offset: 0
    });
    /* 歌单评论请求数据 */

    var listCmtResData = reactive({
      id: route.params.id,
      limit: 30,
      offset: 0
    });
    /* 此处处理转移至下面watchEffect */
    // store.dispatch("Detail/getPlayListDetai", route.params.id);
    // store.dispatch("Detail/getListAllMusic", listResData);
    // store.dispatch("Detail/getListCommentUrl", listCmtResData);

    /* 导航点击事件 */

    var titleClick = function titleClick(index) {
      isShow.value = index;
    };
    /* 评论页数改变事件 */


    var changeCurrent = function changeCurrent(page) {
      state.commentList.value.comments.length = 0;
      listCmtResData.offset = (page - 1) * listCmtResData.limit;
      store.dispatch("Detail/getListCommentUrl", listCmtResData);
    };
    /* 当路由id变化则重新请求数据 */


    watch(function () {
      return route.params.id;
    }, function () {
      if (route.path.indexOf("/main/playlistdetail") !== -1) {
        store.dispatch("Detail/getPlayListDetai", route.params.id);
        store.dispatch("Detail/getListAllMusic", listResData);
        store.dispatch("Detail/getListCommentUrl", listCmtResData);
      }
    }, {
      immediate: true
    });
    return _objectSpread(_objectSpread({
      isShow: isShow
    }, state), {}, {
      route: route,
      listResData: listResData,
      listCmtResData: listCmtResData,
      navList: navList,
      curtpage: curtpage,
      titleClick: titleClick,
      changeCurrent: changeCurrent
    });
  },
  components: {
    ListDetailTop: ListDetailTop,
    ListDetail: ListDetail,
    Comment: Comment,
    Loading: Loading,
    ListDetailNav: ListDetailNav
  }
});